export default __webpack_public_path__ + "static/media/logout-img-croped.6341cad9.png";